export const getAllPresentationService = async () => {
  const URL = `/presentation`;  
  const query = await fetch(URL)  
  const jsonData = await query.json();  
  return jsonData;
}
